import { ActivityLog } from 'src/graphql/generated/types';
import { TFunction } from 'i18next';
import { mapActivityToMessage, normalizeActivityMessageInput } from './activityMessageMapper';
import { ActivityViewModel } from './activityViewModel';

export const mapActivityToViewModel = (activity: ActivityLog, t: TFunction): ActivityViewModel | null => {
    const normalizedActivity = normalizeActivityMessageInput({
        activityType: activity.activityType,
        activityDetails: activity.activityDetails,
        targetResource: {
            orgName: activity.targetResource.orgName,
            userName: activity.targetResource.userName,
            userEmail: activity.targetResource.userEmail,
            licenseSystemId: activity.targetResource.licenseSystemId,
        },
    });

    if (!normalizedActivity) return null;

    return {
        id: activity.activityId,
        performedBy: activity.actingUser.name || '-',
        performedByEmail: activity.actingUser.email || '-',
        targetOrganizationName: activity.targetResource.orgName || '-',
        activity: mapActivityToMessage(normalizedActivity, t),
        date: activity.timestamp,
    };
};

export const mapActivitiesToViewModels = (activities: ActivityLog[], t: TFunction): ActivityViewModel[] =>
    activities
        .map((activity) => mapActivityToViewModel(activity, t))
        .filter((activity): activity is ActivityViewModel => activity !== null);
